import { render, staticRenderFns } from "./PromotionPlans.vue?vue&type=template&id=2b0ca91a&scoped=true&"
import script from "./PromotionPlans.vue?vue&type=script&lang=js&"
export * from "./PromotionPlans.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPlans.vue?vue&type=style&index=0&id=2b0ca91a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0ca91a",
  null
  
)

export default component.exports